import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I kicked myself in the balls",
  "description": "",
  "published": "2011-12-05T00:00:00.000Z",
  "redirect_from": ["/blog/i-kicked-myself-in-the-balls/swizec/3115"],
  "categories": "bugs, coding, Ljubljana, Sunday, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Nice sunny Sunday here in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.0555555556,14.5083333333&spn=0.1,0.1&q=46.0555555556,14.5083333333%20(Ljubljana)&t=h",
        "title": "Ljubljana"
      }}>{`Ljubljana`}</a>{` yesterday. Around noon something particularly odd happened though. The week was over. I had finished everything I absolutely had to do, there was no more coursework, no more tasks for this week in pivotaltracker ... nothing.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/Screen-Shot-2011-12-05-at-12.34.59-PM.png",
        "alt": "The tweet that sealed my fate",
        "title": "The tweet that sealed my fate"
      }}></img></p>
    <p>{`14 hours of pure unadulterated freedom.`}</p>
    <p>{`I felt drunk. I didn't know how to handle myself. Can't even remember the last time I had free time and didn't have to worry about everything lurking on the other end.`}</p>
    <blockquote>
      <h2 parentName="blockquote" {...{
        "id": "a-couple-of-lessons"
      }}>{`A couple of lessons`}</h2>
      <ol parentName="blockquote">
        <li parentName="ol">{`Your code is broken, you just don't know it yet`}</li>
        <li parentName="ol">{`Rejoice about free time and you `}<em parentName="li">{`will`}</em>{` jinx it`}</li>
        <li parentName="ol">{`Take advantage of free time `}<em parentName="li">{`immediately`}</em></li>
        <li parentName="ol">{`Internet Explorer has almost matured into a browser`}</li>
      </ol>
      <p parentName="blockquote">{`But everybody already learned those lessons long ago right?`}</p>
    </blockquote>
    <p>{`Having unscheduled time plomped into your lap like this is strange. There are a bunch of things you've been putting off for months that you could do, there's that book or three that have been waiting for attention since two summers ago, books you bought a month ago but only read 100 pages of, hell, it's sort of sunny outside and maybe you should venture out on that `}<a parentName="p" {...{
        "href": "http://instagr.am/p/WeRpv/"
      }}>{`new longboard`}</a>{` despite somewhat wet conditions?`}</p>
    <p>{`The abundance of choice is truly paralyzing ... until somebody helps out.`}</p>
    <p>{`I did end up going for that longboard ride and started working on fixing up some outstanding bugs on my blog, there's that mobile mode people have been crying about for months, the footer was broken and I even flirted with a small hack project that's been rolling around my head for weeks.`}</p>
    <p>{`Not two hours after I set out on the epic fixing of everything that the US woke up and somebody decided to test my code before pushing to production.`}</p>
    <p>{`It broke. Three small issues. Just an hour or two to fix surely. Small bug on IE, but I'm sure I can find a windows box in the apartment somewhere to figure it out ...`}</p>
    <p>{`Seven hours, two very deep bugs of which the reported bugs were just symptoms, one very strange django QuerySet behavior and two cups of tea later ... it worked. Everything worked. We pushed to production and I collapsed into bed.`}</p>
    <p>{`So much for my free Sunday.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://thedailylongboarder.wordpress.com/2011/09/27/day-4-longboarding-101/"
        }}>{`Day 4 - Longboarding 101`}</a>{` (thedailylongboarder.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.travelpod.com/travel-blog-entries/adambrownell/1/1321987855/tpod.html"
        }}>{`Welcome back to the European Union - Ljubljana, Slovenia`}</a>{` (travelpod.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://jezebel.com/5864948/first-grader-kicks-bully-in-the-balls-sparks-sexual-harassment-investigation"
        }}>{`First Grader Kicks Bully In The Balls, Sparks Sexual Harassment Investigation `}{`[`}{`Kids Today`}{`]`}</a>{` (jezebel.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.wanderingearl.com/im-in-love-with-ljubljana/"
        }}>{`I'm In Love With Ljubljana`}</a>{` (wanderingearl.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=d4491664-5c1e-4068-983b-bf4398ecf699",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      